import { ICalendarDay } from '../models/dashboard.model'

export const getMonthYearString = (date: Date): string =>
    date.toLocaleString('default', { month: 'long', year: 'numeric' })

export const isToday = (day: number, currentDate: Date): boolean => {
    const today = new Date()
    return (
        day === today.getDate() &&
        currentDate.getMonth() === today.getMonth() &&
        currentDate.getFullYear() === today.getFullYear()
    )
}

export const generateCalendarDays = (
    currentDate: Date,
    calendarEvents: number[],
): ICalendarDay[] => {
    const year = currentDate.getFullYear()
    const month = currentDate.getMonth()
    const firstDay = new Date(year, month, 1)
    const lastDay = new Date(year, month + 1, 0)
    const prevMonthDays = firstDay.getDay()
    const prevMonthLastDay = new Date(year, month, 0).getDate()
    const nextMonthDays = 6 - lastDay.getDay()

    const calendarDays: ICalendarDay[] = []

    // Previous month days
    for (let i = prevMonthDays - 1; i >= 0; i--) {
        const day = prevMonthLastDay - i
        calendarDays.push({
            day,
            isCurrentMonth: false,
            isToday: false,
            hasEvent: calendarEvents.includes(day),
        })
    }

    // Current month days
    for (let i = 1; i <= lastDay.getDate(); i++) {
        calendarDays.push({
            day: i,
            isCurrentMonth: true,
            isToday: isToday(i, currentDate),
            hasEvent: calendarEvents.includes(i),
        })
    }

    // Next month days
    for (let i = 1; i <= nextMonthDays; i++) {
        calendarDays.push({
            day: i,
            isCurrentMonth: false,
            isToday: false,
            hasEvent: calendarEvents.includes(i),
        })
    }

    return calendarDays
}

export const getPreviousMonth = (date: Date): Date =>
    new Date(date.getFullYear(), date.getMonth() - 1, 1)

export const getNextMonth = (date: Date): Date =>
    new Date(date.getFullYear(), date.getMonth() + 1, 1)
